//utility function that takes in the segments and parse through all the nodes
//  Example
/*
present.wheel_segments = updateWheelSegmentsNodes(
    present.wheel_segments,
    (node) => {
      if (node.type?.resolvedName === "ContainerWidget" && node.props) {
        node.props.radius = newCornerRounding;
      } else if (node?.props?.borderRadius) {
        node.props.borderRadius = newCornerRounding;
      }
    }
  );
  */

export const updateWheelSegmentsNodes = (segments, updater) => {
  return segments.map((segment) => {
    if (!segment.nodes) return segment;

    try {
      const parsedNodes = JSON.parse(segment.nodes);
      Object.entries(parsedNodes).forEach(([key, node]) => {
        updater(node); // Apply changes using the provided updater
      });
      segment.nodes = JSON.stringify(parsedNodes);
    } catch (error) {
      console.error("Error updating nodes:", error);
    }

    return segment;
  });
};

export function convertGlobalSettingsToApiFormat(globalSettings) {
  if (!globalSettings) return null;

  return {
    heading: {
      font_color: globalSettings?.headingProps?.fontColor || "black",
      font_family: globalSettings?.headingProps?.fontFamily || "Poppins",
      font_size: globalSettings?.headingProps?.fontSize || 20,
      reset_key: globalSettings?.headingProps?.resetKey || 0,
    },
    paragraph: {
      font_color: globalSettings?.paragraphProps?.fontColor || "black",
      font_family: globalSettings?.paragraphProps?.fontFamily || "Poppins",
      font_size: globalSettings?.paragraphProps?.fontSize || 14,
      reset_key: globalSettings?.paragraphProps?.resetKey || 0,
    },
    line_height: globalSettings?.lineHeight || 1.15,
    corner_radius: globalSettings?.cornerRounding || 8,
    border_thickness: globalSettings?.borderThickness || 8,
    margin: {
      top: globalSettings?.margin?.top || 20,
      bottom: globalSettings?.margin?.bottom || 20,
      left: globalSettings?.margin?.left || 20,
      right: globalSettings?.margin?.right || 20,
    },
  };
}

// Ported from `dev` 2026-09-18. `pages/SegmentBuilder/index.jsx` imports this
// name and CALLS it on the wheel-load failure path, but the port that brought
// the import never brought the export -- so a wheel that fails to load threw
// "resolveWheelLoadError is not a function" and replaced the friendly message
// with the error boundary. Same port-gap class as
// findSegmentExceedingCharLimit (SegmentsTabHelpers.js).
export function resolveWheelLoadError(error) {
  const data = error?.response?.data;
  const message =
    data?.message ||
    data?.detail ||
    "This Wheel couldn't be opened. It may have been deleted or is no longer available.";
  return { message, redirect: true };
}

export function revertGlobalSettingsFromApiFormat(apiGlobalSettings) {
  if (!apiGlobalSettings) return null;

  return {
    headingProps: {
      fontColor: apiGlobalSettings?.heading?.font_color || "black",
      fontFamily: apiGlobalSettings?.heading?.font_family || "Poppins",
      fontSize: apiGlobalSettings?.heading?.font_size || 20,
      resetKey: apiGlobalSettings?.heading?.reset_key || 0,
    },
    paragraphProps: {
      fontColor: apiGlobalSettings?.paragraph?.font_color || "black",
      fontFamily: apiGlobalSettings?.paragraph?.font_family || "Poppins",
      fontSize: apiGlobalSettings?.paragraph?.font_size || 14,
      resetKey: apiGlobalSettings?.paragraph?.reset_key || 0,
    },
    lineHeight: parseFloat(apiGlobalSettings?.line_height) || 1.15,
    cornerRounding: apiGlobalSettings?.corner_radius || 8,
    borderThickness: apiGlobalSettings?.border_thickness || 8,
    margin: {
      top: apiGlobalSettings?.margin?.top || 20,
      bottom: apiGlobalSettings?.margin?.bottom || 20,
      left: apiGlobalSettings?.margin?.left || 20,
      right: apiGlobalSettings?.margin?.right || 20,
    },
  };
}
